import { Button } from '@iwoca/orion';

import ErrorCircle from '../../../../../components/svg/ErrorCircle.svg';
import { WhiteLabelOverride } from '../../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { IwocaToBankIllustration } from '../IwocaToBankIllustration/IwocaToBankIllustration';

export const Failed = ({ finishDrawDown }: { finishDrawDown: () => void }) => {
  return (
    <div className="m-auto">
      <div className="text-l font-bold">
        Unfortunately, we have not been able to process the payment.
      </div>
      <IwocaToBankIllustration
        icon={
          <span className="h-full min-h-[100px] w-[2px] border-l border-dashed border-error m700:h-[2px] m700:min-h-0 m700:w-full m700:border-b m700:border-l-0 m700:border-dashed m700:border-success-drk">
            <img
              alt="Error"
              src={ErrorCircle}
              className="relative top-[5px] ml-[-44px] m700:top-0 m700:ml-0 m700:mt-[-40px]"
            />
          </span>
        }
      />
      <WhiteLabelOverride componentType="button" disabled={false}>
        <Button
          variant="primary"
          className="!px-5xl !py-l"
          onClick={finishDrawDown}
        >
          Close
        </Button>
      </WhiteLabelOverride>
    </div>
  );
};
